import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ContractAppService from '../../../../application/platform/scp/contract/contract-app-service';
import { ACTION_TYPES, useAmendmentListDispatch, useAmendmentListState } from './amendment-list-context';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { IAmendmentPagedResponse } from '../../../../model/scp/contract/amendment/response/amendment-paged-response';

export const useAmendmentListController = () => {
    const navigate = useNavigate();
    const { run } = useActionRunner();
    const dispatch = useAmendmentListDispatch();
    const { contractId } = useAmendmentListState();

    // O número do processo identifica o contrato no título; a lista funciona mesmo se a consulta falhar
    useEffect(() => {
        run('Não foi possível carregar as informações do contrato', async () => {
            const data = await ContractAppService.getContract(contractId);
            dispatch({ type: ACTION_TYPES.setProcessNumber, payload: data.processNumber });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractId]);

    function navigateToCreate() {
        navigate(`/contratos/${contractId}/aditivos/publicar`);
    }

    function navigateToEdit(row: IAmendmentPagedResponse) {
        navigate(`/contratos/${contractId}/aditivos/publicar/${row.sequentialContractTerm}`);
    }

    return { navigateToCreate, navigateToEdit };
};
